class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.productForm = this.closest('lq-duo_subscription').querySelector(`product-form`);
    this.mediaGallery = this.closest('lq-duo_subscription').querySelector('media-gallery');
    this.sellingPlansWidget = this.closest('lq-duo_subscription').querySelector('selling-plans-widget');
  }

  connectedCallback() {
    this.render();
    this.initTabs();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <slot></slot>
    `;
  }

  initTabs() {
    const tabLinks = this.querySelectorAll('.tabs__link');
    const tabPanes = this.querySelectorAll('.tabs__pane');

    tabLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.activateTab(link, tabLinks, tabPanes);
      });
    });

    // Activate the first tab without triggering a click event
    if (tabLinks.length > 0) {
      this.activateTab(tabLinks[0], tabLinks, tabPanes);
    }
  }

  activateTab(link, tabLinks, tabPanes) {
    tabLinks.forEach(l => l.classList.remove('tabs__link--active'));
    link.classList.add('tabs__link--active');

    tabPanes.forEach(pane => pane.classList.remove('tabs__pane--active'));

    const targetPane = document.querySelector(link.getAttribute('href'));
    targetPane.classList.add('tabs__pane--active');

    this.updateMediaGallery(link.getAttribute('href'));
    this.resetSelectedRadioButtons();
    this.hideVariantImages();
  }

  hideVariantImages() {
    const variantImages = this.mediaGallery.querySelectorAll('[data-variant-id]');
    variantImages.forEach(image => image.classList.add('hidden'));
  }

  resetSelectedRadioButtons() {
    const radioButtons = this.querySelectorAll('input[type="radio"]:checked');
    radioButtons.forEach(radio => {
      radio.checked = false;
    });
    this.productForm?.toggleSubmitButton(true, window.variantStrings.selectVariant);
    this.sellingPlansWidget.toggleAllElements(true);
  }

  updateMediaGallery(tabId) {
    const image = this.mediaGallery.querySelector(`[data-image-id="${tabId.replace('#', '')}"]`);
    if (image) {
      // Hide all images
      this.mediaGallery.querySelectorAll('[data-image-id]').forEach(img => img.classList.add('hidden'));

      // Show the selected image
      image.classList.remove('hidden');
    }
  }
}

customElements.define('tabs-component', TabsComponent);

if (!customElements.get('lq-duo_subscription')) {
  customElements.define(
    'lq-duo_subscription',
    class LqDuoSubscription extends HTMLElement {
      constructor() {
        super();
        this.productForm = this.querySelector(`product-form`);
        this.sellingPlansWidget = this.querySelector('selling-plans-widget');
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.productForm?.toggleSubmitButton(true);
        this.sellingPlansWidget.toggleAllElements(true);
      }

      handleOptionValueChange({ data: { event, target } }) {
        //console.log('event', event, target);
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        this.updateOptionValues(target);

      }

      resetProductFormState() {
        this.productForm?.toggleSubmitButton(true);
        this.sellingPlansWidget.toggleAllElements(true);
        this.productForm?.handleErrorMessage();
      }

      updateOptionValues(target) {
        const productId = target.closest('variant-selects').dataset.productId;
        const variantData = this.findJsonInScript(productId, target.value);

        this.productForm.querySelector('.product-variant-id').value = variantData.id;
        this.updateMedia(variantData, target.closest('variant-selects').dataset.productImage);
        if (!variantData.available) {
          this.productForm.toggleSubmitButton(true, window.variantStrings.soldOut);
          this.sellingPlansWidget.toggleAllElements(true);
        } else {
          this.productForm.toggleSubmitButton(false);
          this.sellingPlansWidget.toggleAllElements(false);
        }
      }

      updateMedia(data, productImage) {
        const mediaGallery = this.querySelector('media-gallery');
        const imageHolder = mediaGallery.querySelector(`[data-variant-id]`);
        const image = imageHolder.querySelector('img');
        if (imageHolder) {
          const image = imageHolder.querySelector('img');
          if (image) {
            if (data.featured_image) {
              image.src = data.featured_image.src
            } else  {
              image.src = productImage;
            }
            mediaGallery.querySelectorAll('[data-image-id]').forEach(img => img.classList.add('hidden'));
            imageHolder.classList.remove('hidden');
          }
        }
      }

      findJsonInScript(productId, variantTitle) {
        const script = document.querySelector(`script[data-product-variants="${productId}"][data-variant-title="${variantTitle}"]`);
        if (script) {
          try {
            return JSON.parse(script.textContent);
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Script with specified attributes not found');
        }
        return null;
      }

    }
  );
}